module.exports = __webpack_public_path__ + "static/gilroy-medium-5c1e574883aeccf0f98afb84482f3839.otf";